module.exports = __webpack_public_path__ + "static/media/loginCode.145e6e61.svg";